$ = require 'jquery'
{ forEach } = require 'lodash'

module.exports =
class Elements

  @selectors:
    window      : window
    document    : document
    body        : 'body'
    wrap        : '.wrap'
    sections    : '.sections'
    sectionsInr : '.sections-inner'
    logo        : '.head-logo'
    nav         : '.side-nav'
    navIndicator: '.side-nav .nav-dots li'
    navMore     : '.side-nav .plus-more'
    menuBtn     : '.menu-button'
    copyright   : '.copyright'

  constructor: ->
    forEach Elements.selectors, (selector, name) ->
      selectorName = "$#{name}"
      Elements[selectorName] = $ selector



// WEBPACK FOOTER //
// ./webpack/requires/pc/views/elements.coffee